// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AnalyticsAdminItemPagingResultModel from '../../model/analytics-admin-item-paging-result-model';
import AnalyticsAdminItemPagingResultDTO from '../dto/analytics-admin-item-paging-result-dto';
import dtoSchema from '../schemas/analytics-admin-item-paging-result-schema';
import AnalyticsAdminItemModel from '../../model/analytics-admin-item-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class AnalyticsAdminItemPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AnalyticsAdminItemPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => AnalyticsAdminItemModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: AnalyticsAdminItemModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<AnalyticsAdminItemPagingResultDTO>): AnalyticsAdminItemPagingResultModel;
  static toModel(dto: DeepPartial<AnalyticsAdminItemPagingResultDTO> | undefined | null): AnalyticsAdminItemPagingResultModel | undefined;
  static toModel(dto: DeepPartial<AnalyticsAdminItemPagingResultDTO> | undefined | null): AnalyticsAdminItemPagingResultModel | undefined {
    return dto ? new AnalyticsAdminItemPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AnalyticsAdminItemPagingResultModel> | AnalyticsAdminItemPagingResultModel): AnalyticsAdminItemPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as AnalyticsAdminItemPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AnalyticsAdminItemPagingResultModel, can not map to AnalyticsAdminItemPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
